// @ts-strict-ignore
import { getFakeGetFetcherFunctions } from "../../fakingUtils";

import { appsAppGroupIdChartsRevenueLifetimeStats } from "../constants";
import { fakeAppGroupRevenueLifetimeStatsResults } from "./constants";
import { getAppGroupRevenueLifetimeStats } from "../getAppGroupRevenueLifetimeStats";

/**
 * A fake fetcher function, for use in faking the "/apps/:app_group_id/charts/revenue/lifetime_stats" GET endpoint in storybook
 * using <FakeDashboardApiProvider>
 */
const fakeGetAppGroupRevenueLifetimeStatsFetchers = getFakeGetFetcherFunctions({
  cacheKey: appsAppGroupIdChartsRevenueLifetimeStats,
  baseFakeThing: fakeAppGroupRevenueLifetimeStatsResults,
  realFetcher: getAppGroupRevenueLifetimeStats,
});

export { fakeGetAppGroupRevenueLifetimeStatsFetchers };
